var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGenerateSpis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.023,16.784h-12.045c-.658,0-1.193.535-1.193,1.193v12.045c0,.658.535,1.193,1.193,1.193h12.045c.658,0,1.193-.535,1.193-1.193v-12.045c0-.658-.535-1.193-1.193-1.193ZM28.477,25.034h-3.443v3.443c0,.571-.463,1.034-1.034,1.034s-1.034-.463-1.034-1.034v-3.443h-3.443c-.571,0-1.034-.463-1.034-1.034s.463-1.034,1.034-1.034h3.443v-3.443c0-.571.463-1.034,1.034-1.034s1.034.463,1.034,1.034v3.443h3.443c.571,0,1.034.463,1.034,1.034s-.463,1.034-1.034,1.034Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.568,2h-13.955c-2.962,0-5.364,2.401-5.364,5.364v33.273c0,2.962,2.401,5.364,5.364,5.364h24.773c2.962,0,5.364-2.401,5.364-5.364v-22.455c0-8.937-7.245-16.182-16.182-16.182ZM33.284,30.023c0,1.798-1.463,3.261-3.261,3.261h-12.045c-1.798,0-3.261-1.463-3.261-3.261v-12.045c0-1.798,1.463-3.261,3.261-3.261h12.045c1.798,0,3.261,1.463,3.261,3.261v12.045Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGenerateSpis);
export default __webpack_public_path__ + "static/media/icon-generate-spis.c5c9e31eb307dece580ea7501b79a33e.svg";
export { ForwardRef as ReactComponent };